"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _coreIcon = _interopRequireDefault(require("@legacy-vfuk/core-icon"));

var _coreLink = _interopRequireDefault(require("@legacy-vfuk/core-link"));

var _coreHeading = _interopRequireDefault(require("@legacy-vfuk/core-heading"));

var _coreBaseProps = require("@legacy-vfuk/core-base-props");

var Styled = _interopRequireWildcard(require("./styles/CardHeadingAndIconSlot.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CardHeadingAndIconSlot = function CardHeadingAndIconSlot(_ref) {
  var _icon$justify, _icon$justify2;

  var heading = _ref.heading,
      icon = _ref.icon,
      prefix = _ref.prefix,
      suffix = _ref.suffix,
      link = _ref.link,
      _ref$subIconGroup = _ref.subIconGroup,
      subIconGroup = _ref$subIconGroup === void 0 ? 'system' : _ref$subIconGroup,
      _ref$subIcons = _ref.subIcons,
      subIcons = _ref$subIcons === void 0 ? [] : _ref$subIcons,
      subIconSeparatorText = _ref.subIconSeparatorText,
      _ref$level = _ref.level,
      level = _ref$level === void 0 ? 1 : _ref$level,
      id = _ref.id,
      dataSelectorPrefix = _ref.dataSelectorPrefix,
      dataAttributes = _ref.dataAttributes;
  var componentName = 'CardHeadingAndIconSlot';
  var subIconsWithGroup = (0, _react.useMemo)(function () {
    return subIcons.map(function (subIcon) {
      return _objectSpread(_objectSpread({}, subIcon), {}, {
        group: subIconGroup
      });
    });
  }, [subIconGroup, subIcons]);
  return /*#__PURE__*/_react["default"].createElement(Styled.CardHeadingAndIconSlot, _extends({
    justifyIcon: (_icon$justify = icon === null || icon === void 0 ? void 0 : icon.justify) !== null && _icon$justify !== void 0 ? _icon$justify : 'left',
    id: id,
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix),
    "data-component-name": componentName
  }, dataAttributes), /*#__PURE__*/_react["default"].createElement(Styled.IconContainer, null, (icon === null || icon === void 0 ? void 0 : icon.component) && !icon.name && icon.component, (icon === null || icon === void 0 ? void 0 : icon.name) && !icon.component && /*#__PURE__*/_react["default"].createElement(_coreIcon["default"], {
    size: 4,
    name: icon.name,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'icon')
  })), /*#__PURE__*/_react["default"].createElement(Styled.HeadingContainer, {
    justifyIcon: (_icon$justify2 = icon === null || icon === void 0 ? void 0 : icon.justify) !== null && _icon$justify2 !== void 0 ? _icon$justify2 : 'left',
    hasIcon: !!icon
  }, prefix && /*#__PURE__*/_react["default"].createElement(Styled.PreffixSuffixContainer, {
    level: level,
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'prefix')
  }, prefix), /*#__PURE__*/_react["default"].createElement(_coreHeading["default"], {
    size: level === 2 ? 1 : 2,
    level: heading.level,
    text: heading.name,
    weight: 3,
    noMargin: true,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'heading')
  }), suffix && /*#__PURE__*/_react["default"].createElement(Styled.PreffixSuffixContainer, {
    level: level,
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'suffix')
  }, suffix), link && /*#__PURE__*/_react["default"].createElement(Styled.LinkContainer, null, /*#__PURE__*/_react["default"].createElement(_coreLink["default"], _extends({}, link, {
    size: 1,
    showUnderline: true,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'link')
  }))), subIconsWithGroup.length > 0 && subIconsWithGroup.map(function (subIconProps, index) {
    var showSeparatorText = index !== 0 && subIconSeparatorText;
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: index
    }, showSeparatorText && /*#__PURE__*/_react["default"].createElement(Styled.IconsSeparatorText, {
      key: "separator-".concat(index),
      "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "icon-text-".concat(index))
    }, subIconSeparatorText), /*#__PURE__*/_react["default"].createElement(_coreIcon["default"], _extends({
      key: "".concat(subIconProps.name, "-").concat(index)
    }, subIconProps, {
      dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "icon-".concat(index))
    })));
  })));
};

CardHeadingAndIconSlot.displayName = "CardHeadingAndIconSlot";
var _default = CardHeadingAndIconSlot;
exports["default"] = _default;
//# sourceMappingURL=CardHeadingAndIconSlot.js.map